import { cn } from "@/lib/utils";

export const tooltipPositionerClass = "z-[var(--z-layer-tooltip)]";

export const TOOLTIP_GAP_OFFSET = 5;

// sideOffset={9} = 4px arrow height + 5px gap
export const TOOLTIP_SIDE_OFFSET = 9;

export const tooltipPopupClass = cn(
  "max-w-[240px]",
  "rounded-(--radius-sm)",
  "px-(--spacing-12) py-(--spacing-8)",
  "bg-surface-inverse-surface",
  "text-text-inverse",
  "shadow-elevation-2",
  "font-(family-name:--font-family-body)",
  "transition-opacity duration-150 ease-in-out",
  "[&[data-starting-style]]:opacity-0",
  "[&[data-ending-style]]:opacity-0",
);

export const tooltipBaseLabelClass = cn(
  "text-(length:--font-size-label-small)",
  "leading-(--font-line-height-16)",
);

export const tooltipDescriptionClass = cn(
  "text-(length:--font-size-label-xs)",
  "font-(number:--font-weight-regular)",
  "leading-(--font-line-height-16)",
  "mt-(--spacing-4)",
);

export const tooltipArrowClass = cn(
  "bg-surface-inverse-surface",
  "[&[data-side=top]]:h-(--spacing-6) [&[data-side=top]]:w-(--spacing-12)",
  "[&[data-side=bottom]]:h-(--spacing-6) [&[data-side=bottom]]:w-(--spacing-12)",
  "[&[data-side=left]]:h-(--spacing-12) [&[data-side=left]]:w-(--spacing-6)",
  "[&[data-side=right]]:h-(--spacing-12) [&[data-side=right]]:w-(--spacing-6)",
  "[&[data-side=top]]:-bottom-(--spacing-4) [&[data-side=top]]:[clip-path:polygon(50%_100%,0%_0%,100%_0%)]",
  "[&[data-side=bottom]]:-top-(--spacing-4) [&[data-side=bottom]]:[clip-path:polygon(50%_0%,0%_100%,100%_100%)]",
  "[&[data-side=left]]:-right-(--spacing-4) [&[data-side=left]]:[clip-path:polygon(100%_50%,0%_0%,0%_100%)]",
  "[&[data-side=right]]:-left-(--spacing-4) [&[data-side=right]]:[clip-path:polygon(0%_50%,100%_0%,100%_100%)]",
);
